module.exports = __webpack_public_path__ + "static/media/Arch--red.b7b7245b.svg";